module.exports = __webpack_public_path__ + "06_long_gold.d2da79b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_long_gold.png
// module id = 98QJ
// module chunks = 0